<template>
  <div id="app">
    <!-- 引入头部 -->
    <v-header></v-header>
    <!-- 主体内容 -->
    <div class="list-content">
      <v-knowledge v-if="path == 'knowledge'"></v-knowledge>
      <Activity v-if="path == 'activity'"></Activity>
      <RecruitInner v-if="path == 'recruitinner'"></RecruitInner>
      <RecruitOuter v-if="path == 'recruitouter'"></RecruitOuter>
      <Industry v-if="path == 'industry'"></Industry>
    </div>
    <!-- 引入返回顶部组件 -->
    <v-backTop></v-backTop>
  </div>
</template>

<script>
  import Header from 'components/header/header';
  import BackTop from 'components/common/backTop';
  import Knowledge from './pages/knowledge';


  export default {
    name: 'app',
    data(){
      return{
        path:'',
        pathArr:['knowledge','activity','recruitinner','recruitouter','industry']
      }
    },
    components: {
      'v-header':Header,
      'v-backTop':BackTop,
      'v-knowledge':Knowledge,
      // Knowledge: resolve => require(['./pages/knowledge'], resolve), // 干货列表
      Activity: resolve => require(['./pages/activity'], resolve),  // 活动列表
      RecruitInner: resolve => require(['./pages/recruit/inner'], resolve),  // 内推列表
      RecruitOuter: resolve => require(['./pages/recruit/outer'], resolve),  // 招聘列表
      Industry: resolve => require(['./pages/industry'], resolve),  // 新闻列表
    },
    methods:{
      getQueryString(name){
        // var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        // var r = window.location.search.substr(1).match(reg);
        // if(r!=null)return  unescape(r[2]); return null;
        return decodeURI(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURI(name).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
      }
    },
    mounted(){
      this.path = this.getQueryString("source");
      // 如果参数错误则跳转到404页面
      if($.inArray(this.path,this.pathArr) === -1){
        window.location.href = '/module/error.html'
      }
    }
  }
</script>

<style>
.list-content{
  margin-top:.5rem;
  font-size: .1rem;
}
</style>



// WEBPACK FOOTER //
// App.vue?16dd42ca